import {
  BOOKS_REQUEST_FETCH_STARTED,
  BOOKS_REQUEST_FETCH_COMPLETED,
  BOOKS_REQUEST_ID_COMPLETED,
  SEARCH_BOOKS_STARTED,
  ADD_BOOK_TO_ORDER,
  ADD_BOOK_TO_ORDER_ERROR,
  NEW_ORDER_REQUEST_STARTED,
  NEW_ORDER_REQUEST_COMPLETED, SEARCH_BOOKS, SUCCESS,
} from '../actions/types';

const initialState = {
  isLoading: false,
  isLibraryDataLoading: false,
  error: '',
  bookOrdersList: [],
  addBooks: {},
  addNewOrderData: {},
  libraryData: [],
  selectBookOrdersByDates: [],
  modalWindow: {
    data: [],
  },
};

export default function booksRequest(state = initialState, action) {
  switch (action.type) {
    case NEW_ORDER_REQUEST_STARTED:
      return {
        ...state,
      };
    case NEW_ORDER_REQUEST_COMPLETED:
      return {
        ...state,
        addNewOrderData: action.data,
      };
    case BOOKS_REQUEST_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case BOOKS_REQUEST_FETCH_COMPLETED:
      return {
        ...state,
        bookOrdersList: action.data,
        isLoading: false,
      };
    case BOOKS_REQUEST_ID_COMPLETED:
      return {
        ...state,
        modalWindow: {
          data: action.data,
        },
      };
    case SEARCH_BOOKS_STARTED:
      return {
        ...state,
        isLibraryDataLoading: true,
      };
    case `${SEARCH_BOOKS}${SUCCESS}`:
      return {
        ...state,
        isLibraryDataLoading: false,
        libraryData: action.data,
      };
    case ADD_BOOK_TO_ORDER:
      return {
        ...state,
      };
    case ADD_BOOK_TO_ORDER_ERROR:
      return {
        ...state,
        error: action.data,
      };
    default:
      return state;
  }
}
